export default __webpack_public_path__ + "images/Explosion-0803abfb4a3ce725885196b9fac4f5d2.png";